import home from './home';
import type { Menu } from './types';
import workspace from './workspace';

export const allMenus: Menu[] = [...home, ...workspace];
